import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const RELOAD_FLAG = 'lazy-with-retry-reloaded';

// React.lazy wrapper for route/tab chunks. When a deploy replaces the hashed
// chunk files while a session is open, the stale index.html requests a chunk
// that no longer exists; instead of white-screening, reload once to pick up the
// new asset manifest. The sessionStorage flag stops a reload loop when the
// import keeps failing for another reason (e.g. offline).
export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const module = await importFn();
      sessionStorage.removeItem(RELOAD_FLAG);
      return module;
    } catch (error) {
      if (!sessionStorage.getItem(RELOAD_FLAG)) {
        sessionStorage.setItem(RELOAD_FLAG, 'true');
        window.location.reload();
        // Keep the Suspense fallback up while the reload happens.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
